module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m-b-5 ovf-hd"
  }, [_c('div', {
    staticClass: "fl w-400"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入企业信息、申请人信息",
      "clearable": ""
    },
    model: {
      value: (_vm.formSearch.name),
      callback: function($$v) {
        _vm.$set(_vm.formSearch, "name", $$v)
      },
      expression: "formSearch.name"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-select', {
    staticClass: "el-input-search m-l-30",
    attrs: {
      "size": "small",
      "placeholder": "归档状态"
    },
    on: {
      "change": function($event) {
        return _vm.search()
      }
    },
    model: {
      value: (_vm.formSearch.status),
      callback: function($$v) {
        _vm.$set(_vm.formSearch, "status", $$v)
      },
      expression: "formSearch.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "待审核",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "通过",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "驳回",
      "value": -1
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "height": _vm.setHeight.page_height,
      "border": ""
    },
    on: {
      "selection-change": _vm.selectItem
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_name",
      "label": "申请人",
      "width": "100",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "申请人电话",
      "width": "150",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rise_company_name",
      "label": "企业全称",
      "width": "200",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rise_discern_code",
      "label": "纳税人识别号",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rise_company_addr",
      "label": "公司注册地址",
      "width": "200",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rise_company_phone",
      "label": "公司联系电话",
      "width": "130",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rise_bank_name",
      "label": "开户行名称",
      "width": "200",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "rise_bank_code",
      "label": "开户银行账号",
      "width": "180",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [(scope.row.status == 1) ? _c('span', {
          staticClass: "success_status"
        }, [_vm._v("通过")]) : (scope.row.status == 0) ? _c('span', {
          staticClass: "goon_status"
        }, [_vm._v("待审核")]) : (scope.row.status == -1) ? _c('span', {
          staticClass: "error_status"
        }, [_vm._v("驳回")]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_c('span', [(scope.row.status == 0) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.shenhe(scope.row)
            }
          }
        }, [_vm._v("审核")]) : _vm._e(), _vm._v(" "), (scope.row.status != 0) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.shenhe(scope.row)
            }
          }
        }, [_vm._v("查看")]) : _vm._e()], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pos-rel p-t-20"
  }, [_c('btnGroup', {
    attrs: {
      "selectedData": _vm.multipleSelection,
      "type": 'company'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block pages"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.limit,
      "current-page": _vm.currentPage,
      "total": _vm.dataCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "审核企业申请",
      "visible": _vm.company_detail_open,
      "custom-class": "w-800 h-800"
    },
    on: {
      "update:visible": function($event) {
        _vm.company_detail_open = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.company_detail,
      "label-width": "250px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业全称："
    }
  }, [_vm._v("\n        " + _vm._s(_vm.company_detail.rise_company_name) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "纳税人识别号："
    }
  }, [_vm._v("\n        " + _vm._s(_vm.company_detail.rise_discern_code) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业注册地址："
    }
  }, [_vm._v("\n        " + _vm._s(_vm.company_detail.rise_company_addr) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业联系电话："
    }
  }, [_vm._v("\n        " + _vm._s(_vm.company_detail.rise_company_phone) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户行名称："
    }
  }, [_vm._v("\n        " + _vm._s(_vm.company_detail.rise_bank_name) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户银行账号："
    }
  }, [_vm._v("\n        " + _vm._s(_vm.company_detail.rise_bank_code) + "\n      ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "w-600",
    attrs: {
      "label": "纳税人性质："
    }
  }, [(_vm.company_detail.vat_type == 1) ? _c('span', [_vm._v("小规模纳税人")]) : _vm._e(), _vm._v(" "), (_vm.company_detail.vat_type == 2) ? _c('span', [_vm._v("一般纳税人")]) : _vm._e()]), _vm._v(" "), (_vm.company_detail.status == 0) ? _c('el-form-item', {
    attrs: {
      "label": "允许使用模块"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.mokuai),
      callback: function($$v) {
        _vm.mokuai = $$v
      },
      expression: "mokuai"
    }
  }, _vm._l((_vm.mokuai_list), function(item) {
    return _c('el-checkbox', {
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.menu_name))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.company_detail.status == 0) ? _c('el-form-item', {
    staticClass: "w-700",
    attrs: {
      "label": ""
    }
  }, [_c('el-button', {
    staticClass: "fr m-l-30",
    attrs: {
      "size": "small",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.save_shenqing(1)
      }
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('el-button', {
    staticClass: "fr",
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.save_shenqing(-1)
      }
    }
  }, [_vm._v("驳回")])], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-346ca9db!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Appistrative/company/company_place/list.vue
// module id = 1827
// module chunks = 2